var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('title-row', {
    attrs: {
      "breadcrumb-items": [{
        text: 'Átjáró riport',
        disabled: true
      }],
      "title": 'Átjáró riport'
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.elementId !== 0 ? _c('title-row-button', {
          attrs: {
            "loading": _vm.isExcelExport,
            "disabled": _vm.isExcelExport
          },
          on: {
            "click": _vm.excelExport
          }
        }, [_c('v-icon', {
          attrs: {
            "large": ""
          }
        }, [_vm._v("mdi-microsoft-excel")])], 1) : _vm._e()];
      },
      proxy: true
    }])
  }), _c('v-expansion-panels', {
    staticClass: "mb-4 rounded-xl overflow-hidden",
    attrs: {
      "value": 0
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_c('span', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-filter")]), _vm._v(" Szűrés ")], 1)]), _c('v-expansion-panel-content', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Elem típus",
      "id": "elementTypeId",
      "items": _vm.elementTypes,
      "item-text": "label",
      "item-value": "value"
    },
    on: {
      "input": function ($event) {
        _vm.elements = [];
        _vm.accesslevels = [];
        _vm.openings = [];
        _vm.elementId = 0;
        _vm.getElements();
      }
    },
    model: {
      value: _vm.elementTypeId,
      callback: function ($$v) {
        _vm.elementTypeId = $$v;
      },
      expression: "elementTypeId"
    }
  })], 1), _vm.elements.length > 0 ? _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Épület",
      "id": "elementId",
      "items": _vm.elements,
      "item-text": "name",
      "item-value": "id"
    },
    on: {
      "input": function ($event) {
        _vm.fetchAccessLevels();
        _vm.fetchOpenings();
      }
    },
    model: {
      value: _vm.elementId,
      callback: function ($$v) {
        _vm.elementId = $$v;
      },
      expression: "elementId"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.elementId !== 0,
      expression: "elementId !== 0"
    }]
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('h2', [_vm._v("Access Levels")]), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.accessLevelHeaders,
      "items": _vm.accesslevels,
      "item-value": "access_level",
      "items-per-page": 5
    },
    scopedSlots: _vm._u([{
      key: "item.allowed",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('ScheduleViewer', {
          attrs: {
            "value": item.allowed,
            "schedule": item.allowed_schedule
          }
        })];
      }
    }, {
      key: "item.denied",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('ScheduleViewer', {
          attrs: {
            "value": item.denied,
            "schedule": item.denied_schedule
          }
        })];
      }
    }, {
      key: "footer.prepend",
      fn: function () {
        return [_c('v-row', {
          staticClass: "px-4"
        }, [_c('v-col', [_c('strong', [_vm._v("Egyéni jogosultságok: " + _vm._s(_vm.accesslevelsSumcards))])])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('h2', [_vm._v("Heti nyitvatartás")]), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.openingHeaders,
      "items": _vm.openings,
      "item-value": "day_name",
      "items-per-page": 7
    }
  }), _c('h2', {
    staticClass: "mt-6"
  }, [_vm._v("Jövőbeli rendhagyó nyitvatartás")]), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.specOpeningHeaders,
      "items": _vm.openingSpecDays,
      "item-value": "date_from"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', [_vm._v("Jövőbeli rendhagyó jogosultságú dátumok")]), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.specDayHeaders,
      "items": _vm.specDays
    },
    scopedSlots: _vm._u([{
      key: "item.access_levels",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('ul', {
          staticStyle: {
            "padding-left": "0"
          }
        }, _vm._l(item.access_levels, function (al) {
          return _c('li', {
            key: al,
            staticStyle: {
              "list-style-type": "none"
            }
          }, [_vm._v(" " + _vm._s(al) + " ")]);
        }), 0)];
      }
    }])
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }